<script>
  export let jsonData = []
  let activeIndex = 0

  const toggle = (index) => {
    activeIndex = activeIndex === index ? null : index
  }

  console.log({ jsonData })
</script>

{#each jsonData as row, index}
  <div class="mb-3 rounded-md border border-[#a0a1a533]">
    <button type="button" class="flex w-full cursor-pointer items-center justify-between rounded-md bg-[#f7f7f7] px-4 py-3 text-gray-800 transition hover:bg-[#a0a1a580] dark:bg-bodyblack dark:text-gray-200 dark:hover:bg-gray-800" on:click={() => toggle(index)}>
      <div>
        <p class="font-semibold text-gray-900 dark:text-gray-200">
          Row {index + 2}
        </p>
      </div>

      <i class="fa-solid fa-chevron-down text-gray-900 transition-transform duration-200 dark:text-gray-200" class:rotate-180={activeIndex === index} />
    </button>

    <!-- Accordion Body -->
    {#if activeIndex === index}
      <div class="space-y-1 p-3">
        <!-- Metadata -->
        <div>
          <h1 class="pb-3 text-xl font-bold dark:text-white">Metadata</h1>

          {#each Object.entries(row.metadata ?? {}) as [section, fields]}
            <div class="rounded-md p-2 pl-4 hover:bg-[#38BDF8]/20">
              <h3 class="mb-2 text-lg capitalize text-blue-500">
                <strong class=" capitalize">{section}</strong>
                details
              </h3>

              {#each Object.entries(fields) as [key, value]}
                <div class="mb-2 px-3">
                  <p class="font-semibold capitalize text-gray-800 dark:text-gray-500">
                    {key}
                  </p>
                  <p class="truncate font-medium capitalize text-gray-200">{value}</p>
                </div>
              {/each}
            </div>
          {/each}
        </div>

        {#if Object.entries(row.options).length}
          <div>
            <h1 class="select-none py-3 text-2xl font-bold text-black dark:text-white">Options</h1>
            <div class="group rounded-md p-2 pl-6 hover:bg-[#38BDF8]/20">
              {#each Object.entries(row.options) as [keys, values]}
                <div class="mb-2 w-full select-none px-3">
                  <p class="font-semibold capitalize text-gray-800 dark:text-gray-500">{keys != "title" ? keys : "Webpage Title"}</p>
                  <p class="truncate font-medium {keys === 'email' ? '' : 'capitalize'} text-gray-200">{keys === "expireOn" && values ? new Date(values).toDateString() : values || "-"}</p>
                </div>
              {/each}
            </div>
          </div>
        {/if}

        {#if row.files && Object.keys(row.files).length}
          <div>
            <h1 class="select-none py-3 text-2xl font-bold text-black dark:text-white">
              Files

              <span class="ml-2 text-sm font-medium text-gray-500">
                {#if Object.keys(row.files).length && Object.keys(row.files).every((k) => k.toLowerCase().startsWith("image-"))}
                  (
                  {Object.keys(row.files).length === 1 ? " Dynamic Image" : " Dynamic Images"}&nbsp;{"(Filename with Filetype eg: .jpg, .jpeg, .png)"}
                  ){:else}
                  Filename (with Filetype eg: .jpg, .jpeg, .png)
                {/if}
              </span>
            </h1>

            <div class="group rounded-md p-2 pl-6 hover:bg-[#38BDF8]/20">
              {#each Object.entries(row.files) as [key, value]}
                <div class="mb-2 w-full select-none px-3">
                  <p class="font-semibold capitalize text-gray-800 dark:text-gray-500">
                    {key}
                  </p>
                  <p class="truncate font-medium text-gray-200">
                    {value}
                  </p>
                </div>
              {/each}
            </div>
          </div>
        {/if}
      </div>
    {/if}
  </div>
{/each}
